import React, { useContext, useEffect } from 'react'
import { View } from 'react-native'
import { Ionicons } from '@expo/vector-icons'
import Animated, {
  cancelAnimation,
  useAnimatedStyle,
  useSharedValue,
  withSequence,
  withTiming,
} from 'react-native-reanimated'
import { ThemeContext } from '../utility/context/ThemeContext'

type Props = {
  size?: number
}

const SuccessAnimation = ({ size = 100 }: Props): React.ReactElement => {
  const theme = useContext(ThemeContext).theme
  const { success } = theme.colors

  // 0.75 -> 1.0 -> 0.9 -> 1.0 bounce-in. Runs once on mount so the success
  // indicator plays through and holds at full size.
  const scale = useSharedValue(0.75)

  useEffect(() => {
    scale.value = withSequence(
      withTiming(1, { duration: 220 }),
      withTiming(0.9, { duration: 140 }),
      withTiming(1, { duration: 160 })
    )
    return () => {
      cancelAnimation(scale)
    }
  }, [scale])

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ scale: scale.value }],
  }))

  return (
    <View style={{ width: size, height: size, alignItems: 'center', justifyContent: 'center' }}>
      <Animated.View style={animatedStyle}>
        <Ionicons name="checkmark-circle" size={size} color={success} />
      </Animated.View>
    </View>
  )
}

export default SuccessAnimation
